export { query } from '../utils/query-store-decorator/query';
export { mutation } from '../utils/query-store-decorator/mutation';
export * from '../utils/query-store-decorator/decorator';
export { refreshOnMount } from '../utils/query-store-decorator/refresh-on-mount';
export type {
    RefreshOnMountDef,
    RefreshTarget,
} from '../utils/query-store-decorator/refresh-on-mount';
export { setupRuntimeQueries } from '../utils/query-store-decorator/runtime-queries';
export type { RuntimeQueries } from '../utils/query-store-decorator/runtime-queries';
export { setupRuntimeMutations } from '../utils/query-store-decorator/runtime-mutations';
export type { RuntimeMutations } from '../utils/query-store-decorator/runtime-mutations';

// Core classes and types — re-exported so composable consumers don't need the main entry
export { QueryApi } from '../utils/query.api';
export type { QueryApiOptions } from '../utils/query.api';
export { MutationApi } from '../utils/mutation.api';
export type { MutationApiOptions } from '../utils/mutation.api';
export { QueryClientStore } from '../utils/query-client.store';
export type { QueryInvalidationOptions } from '../types/query-invalidation-options';
export type { GlobalClientOptions } from '../utils/client-helpers';
export { getQueryClient } from '../utils/get-query-client';
export { PageClientType } from '../types/page-client-type';
export { QueryClient } from '@tanstack/query-core';
export type { QueryKey, MutationKey, QueryClientConfig } from '@tanstack/query-core';
